module.exports = __webpack_public_path__ + "static/media/ct1.1015612d.png";